import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cb339420"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BOX" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "map-box" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "map",
    class: "map"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]

import { onMounted, ref } from "vue";
import AMapLoader from "@amap/amap-jsapi-loader";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const is_move = ref(window.innerWidth < 600);

const map = ref<any>(null);
onMounted(async () => {
  AMapLoader.load({
    key: "98da2fba2ef1027023a833f2fbec7af7",
    version: "2.0", // 指定要加载的 JSAPI 的版本
    plugins: ["AMap.ToolBar"], // 插件列表
  }).then((AMap) => {
    map.value = new AMap.Map("map", {
      center: [121.021248, 31.19317], // 中心点经纬度
      zoom: 18, // 缩放级别
      viewMode: "2D", //设置地图模式
    });

    //添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
    map.value.addControl(new AMap.ToolBar());

    // 创建 InfoWindow 实例，用于显示信息窗口
    const infoWindow = new AMap.InfoWindow({
      isCustom: true, // 使用自定义内容
      offset: new AMap.Pixel(16, -10), // 设置窗口偏移量
    });
    // 设置信息窗口内容
    const con = is_move
      ? `
      <div style='display: flex;padding: 12px 10px;background: #fff;border-radius: 4px; align-items: center;'>
      <img style="width: 65px;height: 60px" src="http://www.feifanbio-tech.com/wp-content/uploads/2025/01/cropped-非凡生命科学站点图标.png" alt="" />
      <div style="flex-shrink: 0;width: 230px;text-align: left;">
        <div style="color: #000;font-size: 16px;font-weight: 700;line-height: 25px;">昆山非凡生命科学产业创新中心</div>
        <div style="color: #57575D;font-size: 16px;line-height: 22.4px;">昆山市淀山湖镇北苑路235号</div>
      </div>
    </div>`
      : `
    <div style='display: flex;padding: 12px 10px;background: #fff;border-radius: 4px; align-items: center;'>
      <img style="width: 65px;height: 60px" src="http://www.feifanbio-tech.com/wp-content/uploads/2025/01/cropped-非凡生命科学站点图标.png" alt="" />
      <div style="text-align: left;">
        <div style="color: #000;font-size: 18px;font-weight: 700;line-height: 25px;">昆山非凡生命科学产业创新中心</div>
        <div style="color: #57575D;font-size: 16px;line-height: 22.4px;">昆山市淀山湖镇北苑路235号</div>
      </div>
    </div>
    `;

    // 打开信息窗口
    infoWindow.setContent(con);
    infoWindow.open(map.value, [121.021248, 31.19317]);

    //创建marker图标的大小和图片路径 ---如果是多个点可把下方代码放入循环进行循环标点
    var startIcon = new AMap.Icon({
      // 图标尺寸
      size: new AMap.Size(64, 64),
      // 图标的取图地址
      image:
        "http://www.feifanbio-tech.com/wp-content/uploads/2025/01/poi-marker-1.png",
      // 图标所用图片大小
      imageSize: new AMap.Size(48, 48),
      // 图标取图偏移量
      imageOffset: new AMap.Pixel(-4, 0),
    });

    //创建点标记
    new AMap.Marker({
      map: map.value,
      icon: startIcon,
      position: [121.021248, 31.19317],
    });
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})